import { Base64 } from "js-base64";

export default function filePerview(baseUrl, filename) {
  let url = `${process.env.VUE_APP_PREVIEW_BASE_URL }#/filePreview?url=${encodeURIComponent(Base64.encode(baseUrl))}&filename=${filename}`;
  const previewWindow = window.open(url, "_blank");

  // 窗口关闭时释放URL资源
  if (previewWindow) {
    previewWindow.onunload = () => {
      URL.revokeObjectURL(url);
    };
  }
}
